export default function getViteBff(): string {
  if (import.meta.env.PROD) {
    return `https://${window.location.host}`;
  }
  return import.meta.env.VITE_BFF;
}
